"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const AgentGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "AGENT-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "evenodd",
    d: "M12.49 1.018a4.982 4.982 0 0 0-5.295 4.476.5.5 0 0 1-.995-.099 5.983 5.983 0 1 1 8.869 5.819.5.5 0 0 1-.488-.873 4.983 4.983 0 0 0-2.091-9.323M5.177 6.986a.5.5 0 0 0-1 0v.499a4.488 4.488 0 0 0 4.045 4.466 1.996 1.996 0 1 0 .012-1.005 3.488 3.488 0 0 1-3.057-3.461v-.499Zm3.987 4.486a.995.995 0 1 1 1.99 0 .995.995 0 0 1-1.99 0m3.04 3.446a5.707 5.707 0 0 1 3.443 1.125l-3.403 3.829-3.403-3.829a5.707 5.707 0 0 1 3.363-1.125m-.007-1a6.706 6.706 0 0 0-4.022 1.375l-.923-1.037a.5.5 0 0 0-.702-.044 10.469 10.469 0 0 0-4.667 9.308.5.5 0 0 0 .999-.055 9.469 9.469 0 0 1 3.92-8.212l4.942 5.561v2.493a.5.5 0 1 0 1 0v-2.493l4.943-5.56a9.468 9.468 0 0 1 3.92 8.211.5.5 0 0 0 .998.056 10.468 10.468 0 0 0-4.667-9.31.5.5 0 0 0-.702.045l-.922 1.037a6.707 6.707 0 0 0-4.117-1.375",
    clipRule: "evenodd"
  }));
};
AgentGraphicIcon.displayName = "AgentGraphicIcon";
AgentGraphicIcon.iconName = "Agent";
export default AgentGraphicIcon;